export default __webpack_public_path__ + "static/media/ferrero-header-logo.2f6c3eff.png";